/**
 * Reminders for Google Calendar™
 *
 * Although its content script only runs on calendar.google.com, its single
 * web-accessible-resource entry exposes every `.js`, `.css`, `.svg` and `.png` to every
 * origin with no `use_dynamic_url`. So the bundled vendor art — content/logo.svg,
 * purpleLogo.svg — plus its stylesheets are all fetchable from any page at a stable URL,
 * which makes detection conclusive and site-independent.
 *
 * Manifest verified against version 8.1.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oolbjiianecoijlgkhopbmhnliajjnnm';

export const remindersForGoogleCalendar: ExtensionDefinition = {
  id: ID,
  name: 'Reminders for Google Calendar™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 50_000,
  notes:
    'All .svg / .png / .js / .css exposed to every origin with no dynamic URL. The ' +
    'vendor logo SVGs load without a CORS grant and are conclusive.',
  signals: [
    {
      id: 'war-content-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Load content/logo.svg via <img> — a vendor logo exposed to every origin; needs ' +
        'no CORS grant, so it survives a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'content/logo.svg'),
    },
    {
      id: 'war-purple-logo-svg',
      kind: 'web-accessible-resource',
      description:
        'Load purpleLogo.svg via <img> — a second vendor-named logo, corroborating the ' +
        'identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'purpleLogo.svg'),
    },
    {
      id: 'war-content-ui-index-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch content-ui/index.css — the injected UI stylesheet, a third independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'content-ui/index.css'),
    },
  ],
};
